module.exports = __webpack_public_path__ + "static/img/5.bf25411.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/5.jpg
// module id = 6nGd
// module chunks = 4